import { ADDPURCHASEORDER, GETPURCHASE, GETPURCHASEORDERS, GETQUOTATION, UPDATEPURCHASEORDER } from "../../utils/api"
import axios from "../../utils/axios"

export const addPuchaseOrder=async(payload,callback)=>{
    await axios.post(ADDPURCHASEORDER,payload).then((res)=>{
        callback(res)

    }).catch((err)=>{

    })

}
export const getAllProdct=async(payload,callback)=>{
    await axios.get(GETPURCHASEORDERS+"/"+payload?.billerId).then((res)=>{
        callback(res)

    }).catch((err)=>{

    })

}
export const getAllotation=async(payload,callback)=>{
    await axios.get(GETQUOTATION+"/"+payload?.billerId).then((res)=>{
        callback(res)

    }).catch((err)=>{

    })

}
export const updatePurchase=async(payload,callback)=>{
    await axios.post(UPDATEPURCHASEORDER,payload).then((res)=>{
        callback(res)

    }).catch((err)=>{

    })

}